import { createContext, useContext } from 'react';

// Ngôn ngữ của trang /kai. Chữ do admin nhập (tên bộ sưu tập, tiêu đề, mô tả) giữ nguyên, không tự dịch.
export const KAI_LANGS = [
  { code: 'vi', label: 'Tiếng Việt' },
  { code: 'en', label: 'English' },
  { code: 'ja', label: '日本語' },
  { code: 'zh', label: '中文' },
];

const LANG_KEY = 'kai-lang';

// Lần đầu: theo ngôn ngữ của máy; sau đó nhớ lựa chọn (localStorage có thể bị chặn nên bọc try)
export function initialLang() {
  try {
    const saved = localStorage.getItem(LANG_KEY);
    if (KAI_LANGS.some((l) => l.code === saved)) return saved;
  } catch {}
  const browser = (navigator.language || 'vi').slice(0, 2).toLowerCase();
  return KAI_LANGS.some((l) => l.code === browser) ? browser : 'vi';
}

export function saveLang(code) {
  try {
    localStorage.setItem(LANG_KEY, code);
  } catch {}
}

const MESSAGES = {
  vi: {
    language: 'Ngôn ngữ',
    login: 'Đăng nhập',
    logout: 'Đăng xuất',
    loggedOut: 'Đã đăng xuất',
    loading: 'Đang tải',
    loadError: 'Không tải được thư viện. Vui lòng thử lại sau.',
    newAlbum: '+ Tạo bộ sưu tập',
    noAlbumsAdmin: 'Chưa có bộ sưu tập nào. Bấm "+ Tạo bộ sưu tập" để bắt đầu.',
    noAlbums: 'Chưa có bộ sưu tập nào.',
    noCover: 'Chưa có ảnh',
    mediaCount: '{n} ảnh, video',
    albumImageViews: '{n} lượt xem',
    back: '← Bộ sưu tập',
    albumLoadError: 'Không tải được bộ sưu tập: {error}',
    notFound: 'Không tìm thấy bộ sưu tập này.',
    uploading: 'Đang tải {i}/{n} ({p}%)',
    addMedia: '+ Thêm ảnh, video',
    rename: 'Đổi tên',
    deleteAlbum: 'Xoá bộ sưu tập',
    emptyAlbumAdmin: 'Bộ sưu tập trống. Bấm "+ Thêm ảnh, video" để đăng.',
    emptyAlbum: 'Bộ sưu tập chưa có ảnh nào.',
    prev: 'Ảnh trước',
    next: 'Ảnh sau',
    editInfo: 'Sửa thông tin',
    delete: 'Xoá',
    photoN: 'Ảnh {n}',
    imageViews: '{n} lượt xem',
    sizeLimit: 'ảnh tối đa {img}MB, video tối đa {vid}MB',
    tooBig: 'Quá lớn ({limit}): {files}',
    uploadFailed: 'Không tải lên được: {error}',
    uploadedSome: 'Đã đăng {ok} file, {fail} file lỗi',
    uploadedAll: 'Đã đăng {n} ảnh, video',
    confirmDeleteAlbum: 'Xoá bộ sưu tập "{name}" cùng toàn bộ {n} ảnh, video?',
    albumDeleted: 'Đã xoá bộ sưu tập',
    deleteError: 'Xoá lỗi: {error}',
    confirmDeleteMedia: 'Xoá ảnh/video này?',
    deleted: 'Đã xoá',
    renameAlbum: 'Đổi tên bộ sưu tập',
    albumName: 'Tên bộ sưu tập',
    renamed: 'Đã đổi tên bộ sưu tập',
    infoSaved: 'Đã lưu thông tin',
    createAlbum: 'Tạo bộ sưu tập',
    cancel: 'Huỷ',
    creating: 'Đang tạo...',
    created: 'Đã tạo bộ sưu tập "{name}"',
    title: 'Tiêu đề',
    description: 'Mô tả',
    saving: 'Đang lưu...',
    save: 'Lưu',
    create: 'Tạo',
    searchPlaceholder: 'Tìm bộ sưu tập, ảnh…',
    searchEmpty: 'Không tìm thấy kết quả',
    inCollection: 'Trong "{name}"',
    collections: 'Bộ sưu tập',
    sortNewest: 'Mới nhất',
    sortName: 'Tên A–Z',
    sortLabel: 'Sắp xếp',
    filterAll: 'Tất cả',
    filterPhotos: 'Ảnh',
    filterVideos: 'Video',
    share: 'Chia sẻ',
    linkCopied: 'Đã sao chép link',
    close: 'Đóng',
    rights: 'Bảo lưu mọi quyền.',
    noMatch: 'Không có ảnh, video phù hợp.',
    loginTitle: 'Đăng nhập quản trị',
    loginSubtitle: 'Chỉ tài khoản Google được cấp quyền admin mới quản lý được bộ sưu tập.',
    loginLoading: 'Đang tải nút đăng nhập Google...',
    signingIn: 'Đang đăng nhập...',
    loginInvalid: 'Đăng nhập Google không hợp lệ, vui lòng thử lại',
    loginSuccess: 'Đăng nhập thành công',
    backHome: '← Trang chủ',
    pickImage: '+ Chọn ảnh',
    removeCover: 'Xoá ảnh nền',
    coverRemoved: 'Đã xoá ảnh nền',
    confirmRemoveCover: 'Xoá ảnh nền đầu trang?',
    selectDelete: 'Chọn để xoá',
    selectedN: 'Đã chọn {n}',
    selectAll: 'Chọn tất cả',
    deleteN: 'Xoá {n} mục',
    confirmDeleteN: 'Xoá {n} ảnh, video đã chọn? Không khôi phục được.',
    deletedN: 'Đã xoá {n} ảnh, video',
    deletedSome: 'Đã xoá {ok}, {fail} mục lỗi',
    deleting: 'Đang xoá...',
    editHeader: 'Chỉnh phần đầu trang',
    heroImage: 'Ảnh nền',
    fitCover: 'Lấp đầy khung',
    fitContain: 'Hiện trọn ảnh',
    dragHint: 'Kéo ảnh để chọn phần hiển thị',
    chooseOther: 'Chọn ảnh khác',
    taglineLabel: 'Câu giới thiệu',
    headerSaved: 'Đã lưu phần đầu trang',
    previewDesktop: 'Máy tính',
    previewMobile: 'Điện thoại',
    serverWaking: 'Máy chủ đang khởi động, vui lòng đợi trong giây lát…',
    sessionExpired: 'Phiên đăng nhập đã hết, vui lòng đăng nhập lại',
  },
  en: {
    language: 'Language',
    login: 'Log in',
    logout: 'Log out',
    loggedOut: 'Logged out',
    loading: 'Loading',
    loadError: 'Could not load the gallery. Please try again later.',
    newAlbum: '+ New collection',
    noAlbumsAdmin: 'No collections yet. Click "+ New collection" to start.',
    noAlbums: 'No collections yet.',
    noCover: 'No photos yet',
    mediaCount: '{n} photos & videos',
    albumImageViews: '{n} views',
    back: '← Collections',
    albumLoadError: 'Could not load the collection: {error}',
    notFound: 'Collection not found.',
    uploading: 'Uploading {i}/{n} ({p}%)',
    addMedia: '+ Add photos, videos',
    rename: 'Rename',
    deleteAlbum: 'Delete collection',
    emptyAlbumAdmin: 'This collection is empty. Click "+ Add photos, videos" to upload.',
    emptyAlbum: 'This collection has no photos yet.',
    prev: 'Previous',
    next: 'Next',
    editInfo: 'Edit details',
    delete: 'Delete',
    photoN: 'Photo {n}',
    imageViews: '{n} views',
    imageViews_one: '1 view',
    sizeLimit: 'photos up to {img}MB, videos up to {vid}MB',
    tooBig: 'Too large ({limit}): {files}',
    uploadFailed: 'Upload failed: {error}',
    uploadedSome: 'Uploaded {ok} files, {fail} failed',
    uploadedAll: 'Uploaded {n} photos & videos',
    confirmDeleteAlbum: 'Delete collection "{name}" and all {n} photos & videos?',
    albumDeleted: 'Collection deleted',
    deleteError: 'Delete failed: {error}',
    confirmDeleteMedia: 'Delete this photo/video?',
    deleted: 'Deleted',
    renameAlbum: 'Rename collection',
    albumName: 'Collection name',
    renamed: 'Collection renamed',
    infoSaved: 'Details saved',
    createAlbum: 'New collection',
    cancel: 'Cancel',
    creating: 'Creating...',
    created: 'Created collection "{name}"',
    title: 'Title',
    description: 'Description',
    saving: 'Saving...',
    save: 'Save',
    create: 'Create',
    searchPlaceholder: 'Search collections, photos…',
    searchEmpty: 'No results',
    inCollection: 'In "{name}"',
    collections: 'Collections',
    sortNewest: 'Newest',
    sortName: 'Name A–Z',
    sortLabel: 'Sort',
    filterAll: 'All',
    filterPhotos: 'Photos',
    filterVideos: 'Videos',
    share: 'Share',
    linkCopied: 'Link copied',
    close: 'Close',
    rights: 'All rights reserved.',
    noMatch: 'No matching photos or videos.',
    loginTitle: 'Admin sign-in',
    loginSubtitle: 'Only Google accounts with admin access can manage collections.',
    loginLoading: 'Loading Google sign-in...',
    signingIn: 'Signing in...',
    loginInvalid: 'Google sign-in failed, please try again',
    loginSuccess: 'Signed in',
    backHome: '← Home',
    pickImage: '+ Choose image',
    removeCover: 'Remove cover',
    coverRemoved: 'Cover removed',
    confirmRemoveCover: 'Remove the header cover image?',
    selectDelete: 'Select to delete',
    selectedN: '{n} selected',
    selectAll: 'Select all',
    deleteN: 'Delete {n}',
    confirmDeleteN: 'Delete {n} selected photos & videos? This cannot be undone.',
    deletedN: 'Deleted {n} photos & videos',
    deletedSome: 'Deleted {ok}, {fail} failed',
    deleting: 'Deleting...',
    editHeader: 'Edit header',
    heroImage: 'Background image',
    fitCover: 'Fill frame',
    fitContain: 'Show whole image',
    dragHint: 'Drag the image to choose the visible part',
    chooseOther: 'Choose another image',
    taglineLabel: 'Tagline',
    headerSaved: 'Header saved',
    previewDesktop: 'Desktop',
    previewMobile: 'Phone',
    mediaCount_one: '1 photo or video',
    uploadedAll_one: 'Uploaded 1 photo or video',
    deletedN_one: 'Deleted 1 photo or video',
    confirmDeleteN_one: 'Delete the selected photo or video? This cannot be undone.',
    confirmDeleteAlbum_one: 'Delete collection "{name}" and its 1 photo or video?',
    serverWaking: 'The server is starting up, please wait a moment…',
    sessionExpired: 'Your session has expired, please log in again',
  },
  ja: {
    language: '言語',
    login: 'ログイン',
    logout: 'ログアウト',
    loggedOut: 'ログアウトしました',
    loading: '読み込み中',
    loadError: 'ギャラリーを読み込めませんでした。しばらくしてからもう一度お試しください。',
    newAlbum: '+ コレクションを作成',
    noAlbumsAdmin: 'コレクションはまだありません。「+ コレクションを作成」から始めましょう。',
    noAlbums: 'コレクションはまだありません。',
    noCover: '写真なし',
    mediaCount: '写真・動画 {n} 件',
    albumImageViews: '閲覧 {n} 回',
    back: '← コレクション',
    albumLoadError: 'コレクションを読み込めませんでした：{error}',
    notFound: 'コレクションが見つかりません。',
    uploading: 'アップロード中 {i}/{n}（{p}%）',
    addMedia: '+ 写真・動画を追加',
    rename: '名前を変更',
    deleteAlbum: 'コレクションを削除',
    emptyAlbumAdmin: 'このコレクションは空です。「+ 写真・動画を追加」からアップロードしてください。',
    emptyAlbum: 'このコレクションにはまだ写真がありません。',
    prev: '前へ',
    next: '次へ',
    editInfo: '情報を編集',
    delete: '削除',
    photoN: '写真 {n}',
    imageViews: '閲覧 {n} 回',
    sizeLimit: '写真は最大 {img}MB、動画は最大 {vid}MB',
    tooBig: 'サイズが大きすぎます（{limit}）：{files}',
    uploadFailed: 'アップロードできませんでした：{error}',
    uploadedSome: '{ok} 件をアップロード、{fail} 件は失敗しました',
    uploadedAll: '写真・動画を {n} 件アップロードしました',
    confirmDeleteAlbum: 'コレクション「{name}」と写真・動画 {n} 件をすべて削除しますか？',
    albumDeleted: 'コレクションを削除しました',
    deleteError: '削除できませんでした：{error}',
    confirmDeleteMedia: 'この写真・動画を削除しますか？',
    deleted: '削除しました',
    renameAlbum: 'コレクション名を変更',
    albumName: 'コレクション名',
    renamed: 'コレクション名を変更しました',
    infoSaved: '情報を保存しました',
    createAlbum: 'コレクションを作成',
    cancel: 'キャンセル',
    creating: '作成中...',
    created: 'コレクション「{name}」を作成しました',
    title: 'タイトル',
    description: '説明',
    saving: '保存中...',
    save: '保存',
    create: '作成',
    searchPlaceholder: 'コレクション・写真を検索…',
    searchEmpty: '見つかりませんでした',
    inCollection: '「{name}」内',
    collections: 'コレクション',
    sortNewest: '新しい順',
    sortName: '名前順',
    sortLabel: '並び替え',
    filterAll: 'すべて',
    filterPhotos: '写真',
    filterVideos: '動画',
    share: '共有',
    linkCopied: 'リンクをコピーしました',
    close: '閉じる',
    rights: '無断転載を禁じます。',
    noMatch: '該当する写真・動画はありません。',
    loginTitle: '管理者ログイン',
    loginSubtitle: '管理者権限のある Google アカウントのみコレクションを管理できます。',
    loginLoading: 'Google ログインを読み込み中...',
    signingIn: 'ログイン中...',
    loginInvalid: 'Google ログインに失敗しました。もう一度お試しください',
    loginSuccess: 'ログインしました',
    backHome: '← ホーム',
    pickImage: '+ 画像を選択',
    removeCover: 'カバー画像を削除',
    coverRemoved: 'カバー画像を削除しました',
    confirmRemoveCover: 'ヘッダーのカバー画像を削除しますか？',
    selectDelete: '選択して削除',
    selectedN: '{n} 件選択中',
    selectAll: 'すべて選択',
    deleteN: '{n} 件を削除',
    confirmDeleteN: '選択した写真・動画 {n} 件を削除しますか？元に戻せません。',
    deletedN: '写真・動画を {n} 件削除しました',
    deletedSome: '{ok} 件削除、{fail} 件失敗',
    deleting: '削除中...',
    editHeader: 'ヘッダーを編集',
    heroImage: '背景画像',
    fitCover: '枠いっぱい',
    fitContain: '全体を表示',
    dragHint: '画像をドラッグして表示位置を調整',
    chooseOther: '別の画像を選択',
    taglineLabel: 'キャッチコピー',
    headerSaved: 'ヘッダーを保存しました',
    previewDesktop: 'パソコン',
    previewMobile: 'スマホ',
    serverWaking: 'サーバーを起動しています。しばらくお待ちください…',
    sessionExpired: 'ログインの有効期限が切れました。もう一度ログインしてください',
  },
  zh: {
    language: '语言',
    login: '登录',
    logout: '退出登录',
    loggedOut: '已退出登录',
    loading: '加载中',
    loadError: '无法加载图库，请稍后再试。',
    newAlbum: '+ 新建作品集',
    noAlbumsAdmin: '还没有作品集。点击"+ 新建作品集"开始。',
    noAlbums: '还没有作品集。',
    noCover: '暂无照片',
    mediaCount: '{n} 张照片和视频',
    albumImageViews: '{n} 次浏览',
    back: '← 作品集',
    albumLoadError: '无法加载作品集：{error}',
    notFound: '找不到该作品集。',
    uploading: '正在上传 {i}/{n}（{p}%）',
    addMedia: '+ 添加照片、视频',
    rename: '重命名',
    deleteAlbum: '删除作品集',
    emptyAlbumAdmin: '作品集为空。点击"+ 添加照片、视频"上传。',
    emptyAlbum: '该作品集还没有照片。',
    prev: '上一张',
    next: '下一张',
    editInfo: '编辑信息',
    delete: '删除',
    photoN: '第 {n} 张',
    imageViews: '{n} 次浏览',
    sizeLimit: '照片最大 {img}MB，视频最大 {vid}MB',
    tooBig: '文件过大（{limit}）：{files}',
    uploadFailed: '上传失败：{error}',
    uploadedSome: '已上传 {ok} 个文件，{fail} 个失败',
    uploadedAll: '已上传 {n} 张照片和视频',
    confirmDeleteAlbum: '删除作品集"{name}"及其全部 {n} 张照片和视频？',
    albumDeleted: '作品集已删除',
    deleteError: '删除失败：{error}',
    confirmDeleteMedia: '删除这张照片/视频？',
    deleted: '已删除',
    renameAlbum: '重命名作品集',
    albumName: '作品集名称',
    renamed: '作品集已重命名',
    infoSaved: '信息已保存',
    createAlbum: '新建作品集',
    cancel: '取消',
    creating: '正在创建...',
    created: '已创建作品集"{name}"',
    title: '标题',
    description: '描述',
    saving: '正在保存...',
    save: '保存',
    create: '创建',
    searchPlaceholder: '搜索作品集、照片…',
    searchEmpty: '没有找到结果',
    inCollection: '位于"{name}"',
    collections: '作品集',
    sortNewest: '最新',
    sortName: '名称 A–Z',
    sortLabel: '排序',
    filterAll: '全部',
    filterPhotos: '照片',
    filterVideos: '视频',
    share: '分享',
    linkCopied: '链接已复制',
    close: '关闭',
    rights: '版权所有。',
    noMatch: '没有符合的照片或视频。',
    loginTitle: '管理员登录',
    loginSubtitle: '只有拥有管理员权限的 Google 账号才能管理作品集。',
    loginLoading: '正在加载 Google 登录...',
    signingIn: '正在登录...',
    loginInvalid: 'Google 登录失败，请重试',
    loginSuccess: '登录成功',
    backHome: '← 首页',
    pickImage: '+ 选择图片',
    removeCover: '删除封面',
    coverRemoved: '封面已删除',
    confirmRemoveCover: '删除首页封面图片？',
    selectDelete: '选择删除',
    selectedN: '已选 {n} 项',
    selectAll: '全选',
    deleteN: '删除 {n} 项',
    confirmDeleteN: '删除所选的 {n} 张照片和视频？删除后无法恢复。',
    deletedN: '已删除 {n} 张照片和视频',
    deletedSome: '已删除 {ok} 项，{fail} 项失败',
    deleting: '正在删除...',
    editHeader: '编辑页首',
    heroImage: '背景图片',
    fitCover: '填满画框',
    fitContain: '显示完整图片',
    dragHint: '拖动图片选择显示部分',
    chooseOther: '选择其他图片',
    taglineLabel: '简介语',
    headerSaved: '页首已保存',
    previewDesktop: '电脑',
    previewMobile: '手机',
    serverWaking: '服务器正在启动，请稍候…',
    sessionExpired: '登录已过期，请重新登录',
  },
};

// t('uploading', { i: 1, n: 3, p: 40 }) -> "Đang tải 1/3 (40%)". Có khoá <key>_one và n = 1 thì dùng câu số ít (tiếng Anh)
export function translator(lang) {
  const dict = MESSAGES[lang] || MESSAGES.vi;
  return (key, params = {}) =>
    ((params.n === 1 && dict[key + '_one']) || dict[key] || MESSAGES.vi[key] || key).replace(/\{(\w+)\}/g, (_, name) => (name in params ? params[name] : `{${name}}`));
}

export const KaiLangContext = createContext(translator('vi'));
export const useT = () => useContext(KaiLangContext);
